import { Fragment } from 'react';
import { orgLevels } from '@/mocks/franchiseData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function OrgStructure() {
  return (
    <section className="relative bg-white py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]">
        <img
          src={readdy('org-struct-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">组织架构</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                五级协同体系，保障每一家门店成功
              </h2>
              <p className="text-gray-400 text-sm mt-4 max-w-xl mx-auto">
                从总部到门店，层层支持、级级赋能，构建标准化的连锁运营协同机制
              </p>
            </div>
          </ScrollReveal>

          <div className="flex flex-col lg:flex-row items-stretch justify-center lg:gap-2">
            {orgLevels.map((level, index) => (
              <Fragment key={level.level}>
                <ScrollReveal
                  variant="scale-up"
                  delay={index * 120}
                  className="lg:flex-1 lg:min-w-0"
                >
                  <div className={`${level.color} text-white rounded-2xl p-5 md:p-6 h-full text-center transition-transform hover:-translate-y-1 duration-300`}>
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/15 mx-auto mb-4">
                      <i className={`${level.icon} text-white text-xl`} />
                    </div>
                    <h3 className="text-sm md:text-base font-semibold mb-1">{level.title}</h3>
                    <p className="text-white/50 text-xs mb-3">{level.subtitle}</p>
                    <p className="text-white/70 text-xs leading-relaxed">{level.desc}</p>
                  </div>
                </ScrollReveal>

                {index < orgLevels.length - 1 && (
                  <div className="flex items-center justify-center h-8 lg:h-auto lg:self-center lg:flex-shrink-0">
                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-warm text-white">
                      <i className="ri-arrow-down-line text-xs lg:hidden" />
                      <i className="ri-arrow-right-s-line text-xs hidden lg:block" />
                    </div>
                  </div>
                )}
              </Fragment>
            ))}
          </div>

          <ScrollReveal variant="fade-up" delay={300}>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-5 gap-4">
              {orgLevels.map((level) => (
                <div key={level.level} className="text-center p-3">
                  <p className="text-xs font-medium text-brand-deep">层级 {level.level}</p>
                  <p className="text-xs text-gray-400 mt-0.5">{level.title}</p>
                </div>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}